<script setup lang="ts">
import { markRaw, ref } from 'vue';
import { PiTabDropdown, PiButton, PiIconSolidGear } from '@pappers-fr/pappers-ui';
import { useAuth } from '@/composables/useAuth';
import AuthPage from '@/components/AuthPage.vue';
import PiecesTab from '@/components/PiecesTab.vue';
import Settings from '@/components/Settings.vue';

const activePage = ref<'pieces' | 'settings'>('pieces');
const { isAuthenticated } = useAuth();
</script>

<template>
	<div class="flex flex-col h-full">
		<AuthPage v-if="!isAuthenticated" />
		<template v-else>
			<div class="flex items-center border-b border-neutral-200">
				<PiTabDropdown
					label="Pièces"
					size="sm"
					is-dropdown-disabled
					:is-selected="activePage === 'pieces'"
					@click="activePage = 'pieces'"
				/>
				<PiButton
					class="ml-2"
					type="ghost"
					:color="activePage === 'settings' ? 'primary' : 'muted'"
					size="sm"
					:icon="markRaw(PiIconSolidGear)"
					@click="activePage = activePage === 'settings' ? 'pieces' : 'settings'"
				/>
			</div>

			<div class="flex-1 overflow-y-auto">
				<PiecesTab v-if="activePage === 'pieces'" />
				<Settings v-else @close="activePage = 'pieces'" />
			</div>
		</template>
	</div>
</template>
